import { DialogMod } from '@zawarski/eti-ui';

interface ConfirmDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  message: string;
  onConfirm: () => void;
  processing?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
}

/** Generic delete confirmation. */
const ConfirmDeleteDialog = ({
  open,
  onOpenChange,
  title,
  message,
  onConfirm,
  processing,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
}: ConfirmDeleteDialogProps) => (
  <DialogMod
    open={open}
    onOpenChange={onOpenChange}
    title={title}
    subtitle=''
    size='sm'
    leftBtnTitle={cancelLabel}
    rightBtnTitle={confirmLabel}
    rightBtnVariant='destructive'
    isProcessing={processing}
    onClick={onConfirm}>
    <p className='rep:px-4 rep:py-4 rep:text-sm rep:text-muted-foreground'>{message}</p>
  </DialogMod>
);

export default ConfirmDeleteDialog;
